import React from 'react'
import { CButton, CModal, CModalBody, CModalHeader, CModalTitle, CModalFooter } from '@coreui/react';
import { DatePicker, Flex, Input, Select, Typography } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { MaskedInput } from 'antd-mask-input';
import { paymentsAction } from 'src/store/Slices/Administrator/PaymentsSlice';
import { getUsers } from 'src/store/Slices/DropDownSlice';
import { addClent, editClent, getClientsList, getUserInfo } from 'src/store/Slices/ClientsSlice';
import dayjs from 'dayjs';

const ShowMailingDetail = ({ visible, setVisible, mailInfo, setPage, setPageSize, mailingsContent }) => {

    const dispatch = useDispatch()
    const dateFormatList = ['DD.MM.YYYY'];
    const mailingsModalInfo = useSelector(state => state.MailingsSlice.mailingsModalInfo)
    useEffect(() => {
        
    }, [mailingsModalInfo])
    window.innerWidth >= 768

    return (
        <CModal
            alignment="center"
            visible={visible.open}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setVisible({ open: false}) }}
            keyboard={true}
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    'Просмотр сообщения'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection : 'column' }}>
                <Flex vertical gap={16}>
                    <div>
                        <Typography.Title level={5}>Заголовок</Typography.Title>
                        <div>{mailingsModalInfo?.data?.value?.header}</div>
                    </div>

                    <div>
                        <Typography.Title level={5}>Сообщение</Typography.Title>
                        <div>{mailingsModalInfo?.data?.value?.body}</div>
                    </div>
                </Flex>
            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setVisible({ open: false, flag: '' }) }}
                    className='text-light'
                    color="secondary"
                >
                    Закрыть
                </CButton>
                {/* <CButton onClick={onClickSubmit} className='text-light'>
                    {visible.flag === 'add' ? 'Добавить' : 'Редактировать'}
                </CButton> */}
            </CModalFooter>
        </CModal>
    )
}

export default ShowMailingDetail